export class AssocierPermissionAuProfile {
    permissionId: string;
    profileId: string;
    selected: boolean;
}